<template>
  <div class="code-editor-template col-xs-12 clearfix" :class="isFirst ? 'code-editor-first' : '' ">
    <textarea
        rows="5"
        v-model="query"
        class="code-editor"
        placeholder="sql query"
    ></textarea>
    <div class="col-xs-12">
      <button 
        class="btn btn-xs btn-success btn-sm add-rule" 
        @click.prevent="execute">
         execute
      </button>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'SQLEditor',
    props: {
      sql: {
        type: String
      },
      changeSQLQuery: {
        type: Function
      },
      isFirst: {
        type: Boolean
      }
    },
    data () {
      return {
        query: this.sql
      }
    },
    methods: {
      execute() {
        this.$emit('changeSQLQuery', this.query)
      }
    }
  }
</script>

<style lang="scss">
  .code-editor {
    width: 100%;
    border-color: transparent;
    color: #558697;
  }

  .code-editor-template {
    padding: 8px;
    position: relative;
    border-radius: 3px;
    border: 1px solid #6d77b8;
    border-top: 3px solid #d2d6de;
    margin-bottom: 20px;
    /* width: 100%; */
    box-shadow: 0 1px 1px rgba(0,0,0,0.1);
    border-top-color: #6d77b8;
    background-color: rgba(255, 255, 255, 0.9);
  }

  .code-editor-top,
  .btn-code-editor {
    padding: 0;
  }

  .btn-code-editor button {
    margin-left: 4px;
  }

  .code-editor-offset {
    margin-left: 30px;
  }


  .code-editor-template {
    flex-direction: column;
    .col-lg-1,.col-lg-10,.col-lg-11,.col-lg-12,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-md-1,.col-md-10,.col-md-11,.col-md-12,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-sm-1,.col-sm-10,.col-sm-11,.col-sm-12,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-xs-1,.col-xs-10,.col-xs-11,.col-xs-12,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9 {
        position: relative;
        min-height: 1px;
        padding-right: 15px;
        padding-left: 15px
    }
  }


</style>
